<template>
    <span @click="onIconClick">
        <template v-if="disabled">
            <span
                class="icon"
                :style="{
                    width: `${size}px`,
                    height: `${size}px`,
                    backgroundColor: backgroundColor,
                    borderRadius: {
                        squire: `${(size - 0) / 6}px`,
                        circle: '50%'
                    }[shape]
                }"
            >
                <slot name="icon">
                    <img
                        v-if="yellowIcon"
                        :style="{ width: `${iconSize}px`, height: `${iconSize}px` }"
                        :src="GuidanceIconYellow"
                        class="icon-img"
                    />
                    <img v-else :style="{ width: `${iconSize}px`, height: `${iconSize}px` }" :src="GuidanceIcon" class="icon-img" />
                </slot>
            </span>
        </template>
        <template v-else>
            <el-tooltip class="guidance-tooltip-container" effect="light" :placement="placement">
                <span
                    class="icon"
                    :style="{
                        width: `${size}px`,
                        height: `${size}px`,
                        backgroundColor: backgroundColor,
                        borderRadius: {
                            squire: `${(size - 0) / 6}px`,
                            circle: '50%'
                        }[shape]
                    }"
                >
                    <slot name="icon">
                        <img
                            v-if="yellowIcon"
                            :style="{ width: `${iconSize}px`, height: `${iconSize}px` }"
                            :src="GuidanceIconYellow"
                            class="icon-img"
                        />
                        <img v-else :style="{ width: `${iconSize}px`, height: `${iconSize}px` }" :src="GuidanceIcon" class="icon-img" />
                    </slot>
                </span>
                <div class="content" slot="content" v-html="content" :style="{fontSize: `${fontSize}px`}"></div>
            </el-tooltip>
        </template>
    </span>
</template>
<script>
import GuidanceIcon from '@/assets/img/icon-guidance.svg'
import GuidanceIconYellow from '@/assets/img/icon-guidance-yellow.svg'

export default {
    name: 'GuidanceTooltip',
    data() {
        return {
            GuidanceIcon,
            GuidanceIconYellow
        }
    },
    props: {
        content: {
            type: String,
            default: ''
        },
        size: {
            type: String | Number,
            default: '25'
        },
        iconSize: {
            type: String | Number,
            default: '14'
        },
        placement: {
            type: String,
            default: 'bottom-start'
        },
        shape: {
            type: String,
            default: 'squire'
        },
        backgroundColor: {
            type: String,
            default: '#00b8f5'
        },
        yellowIcon: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        jumpLink: {
            type: String,
            default: ''
        },
        fontSize: {
            type: Number,
            default: 12
        }
    },
    methods: {
        onIconClick() {
            if (this.jumpLink) {
                window.open(this.jumpLink)
            }
        }
    }
}
</script>
<style scoped>
.icon {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 5px;
    cursor: pointer;
}

.icon .icon-img {
    /* width: 90%;
    height: 90%; */
}
.content {
    /* font-size: 12px; */
}
</style>